import { shareRequest } from "@/network/shareRequest.js";

export function setNewShare(data) {
  return shareRequest({
      url: `/api-new/v1/posts/${data.id}/share`,
      method: "post",
      data
  })
}